module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-2 20h-4c-1.106 0-2 .894-2 2v3a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-3c0-1.106-.894-2-2-2H4V4h24v16zm-14.406-2.262c.348.35.91.35 1.258 0l8.886-8.946a.898.898 0 0 0 0-1.266L22.482 6.26a.886.886 0 0 0-1.256 0l-7.004 7.05-3.448-3.47a.886.886 0 0 0-1.256 0L8.26 11.106a.902.902 0 0 0 0 1.266l5.334 5.366z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/inbox-2.js
// module id = 1184
// module chunks = 14